import countriesEn from '~/const/countries-en.json'
import countries from '~/const/countries.json'

export const countriesTranslations: Record<string, string> = countriesEn

export const getCountries = (): IOption[] => {
  return countries
    .map((country) => ({
      label: country.name,
      value: country['alpha-2'],
    }))
    .sort((a, b) => (a.label > b.label ? 1 : b.label > a.label ? -1 : 0))
}

export const getFullNameCountries = (countryCodeArray: string[]): string[] => {
  return countryCodeArray.map((country) => {
    return countriesTranslations[country]
  })
}
